import React from 'react';
import styled from 'styled-components';
import Row from 'components/Common/Row';

import useSearchPlaceholder from '../hooks/useSearchPlaceholder';
import TextInput from '../../../kingpin/atoms/TextInput';

const SearchBarDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 2px 16px;
`;

const StyledSearchInput = styled(TextInput)`
  background: transparent !important;
  font-size: 14px;
  padding: 24px 28px;
  &:focus {
  }
`;

const SearchBar = ({
  searchText,
  isOpen,
  onSearchTextChanged,
}: {
  searchText: string;
  isOpen: boolean;
  onSearchTextChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const placeholder = useSearchPlaceholder();
  if (!isOpen) return <></>;

  return (
    <SearchBarDiv>
      <Row centerAlign style={{ width: '100%' }}>
        <StyledSearchInput
          value={searchText}
          onChange={onSearchTextChanged}
          placeholder={placeholder}
          data-testid="global-search-input"
          inputSize="Medium"
          icon="search"
          width="100%"
          autoFocus
        />
      </Row>
    </SearchBarDiv>
  );
};

export default SearchBar;
